export default {
	status: {
		All: "All",
		Pending: "Pending",
		Frozen: "Frozen",
		Completed: "Completed",
		Undone: "Undone"
	},
	TotalAmount: "Total Amount",
	Profit: "Profit",
	Expire: "Expire"
};
